<template>
  <div>
    <span style="font-size: 12px">
      可以通过手动填写或批量操作来设置产品规格属性
      <!-- <el-link>查看产品规格显示效果</el-link> -->
    </span>
    <div class="block-wrap">
      <el-table height="300px" :data="list">
        <template v-for="item in tableCols">
          <el-table-column :key="item.attrID" :prop="item.name" align="center">
            <template slot="header" slot-scope="scope">
              <span v-if="item.required" style="color: red">*</span>{{ item.name }}
              <el-tooltip v-if="item.headerTip" effect="dark" :content="item.headerTip" placement="top">
                <i class="el-icon-question" />
              </el-tooltip>
              <template v-if="item.attrType == 2">
                <br />
                <el-button type="link" @click="skuBatch(item)">批量设置</el-button></template
              >
            </template>
            <template slot-scope="{ row }" v-if="valueForm[row._skuid]">
              <el-select
                v-if="['1', '2', '3', '4'].includes(item.inputType)"
                :multiple="['2', '4'].includes(item.inputType)"
                :filterable="['1'].includes(item.inputType)"
                :allow-create="['1'].includes(item.inputType)"
                :blur-create="['1'].includes(item.inputType)"
                :default-first-option="['1'].includes(item.inputType)"
                v-model="valueForm[row._skuid][item.name]"
              >
                <el-option v-for="op in item.attrValues" :key="op.attrValueID" :value="op.name" :label="op.name"></el-option>
              </el-select>
              <el-date-picker
                v-else-if="['5'].includes(item.inputType)"
                v-model="valueForm[row._skuid][item.name]"
                type="date"
                placeholder="选择日期"
              >
              </el-date-picker>
              <el-input-number
                v-else-if="['-1'].includes(item.inputType)"
                v-model="valueForm[row._skuid][item.name]"
                :controls="false"
              ></el-input-number>
              <el-input style="width: 156px" v-else-if="item.inputType" v-model="valueForm[row._skuid][item.name]"></el-input>
              <template v-else> {{ valueForm[row._skuid][item.name] }} </template>
            </template>
          </el-table-column>
        </template>
      </el-table>
    </div>
    <BatchDialog ref="BatchDialogRef" @sureFn="sureFn"></BatchDialog>
  </div>
</template>

<script>
import BatchDialog from './batchDialog.vue';
export default {
  inject: {
    isGroupPuhuo: {
      // 是否组合铺货
      default: false,
    },
    platform: {
      default: '',
    },
  },
  model: {
    prop: 'list',
    event: 'change',
  },
  components: {
    BatchDialog,
  },
  props: {
    list: {
      type: Array,
      default() {
        return [];
      },
    },
    tableCols: {
      type: Array,
      default() {
        return [];
      },
    },
    skuSpecificationsKey: {
      type: String,
      default: 'skuSpecifications',
    },
    isBase: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      valueForm: {},
    };
  },
  computed: {},
  watch: {
    list: {
      handler(list) {
        let valueForm = {};
        list.forEach(item => {
          let skuSpecValues = {};
          item[this.skuSpecificationsKey].map(sp => {
            skuSpecValues[sp.name] = sp.value;
          });
          valueForm[item._skuid] = skuSpecValues;
        });
        this.$set(this, 'valueForm', valueForm);
      },
      immediate: true
    },
  },
  methods: {
    // 批量设置
    skuBatch(col) {
      this.$refs.BatchDialogRef.openDialog({ col });
    },
    sureFn(value, col) {
      for (let item in this.valueForm) {
        this.valueForm[item][col.name] = value;
      }
    },
    getValueForm() {
      // getValue 的同时把值更新到 skuList
      this.list.forEach(item => {
        item[this.skuSpecificationsKey].forEach(sp => {
          sp.value = this.valueForm[item._skuid][sp.name];
          sp.valueKey = this.valueForm[item._skuid][sp.name];

          // const select = this.tableCols.find(col => col.name == sp.name);
          // if (select.attrValues && select.attrValues.length) {
          //   const selectedOption = select.attrValues.find(option => option.name == sp.value);
          //   sp.valueKey = selectedOption.attrValueID || sp.valueKey;
          // }
        });
      });
      return this.valueForm;
    },
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
.block-wrap {
  padding-top: 8px;
  border: 1px solid #dcdfe6;
  max-height: 400px;
  overflow-y: auto;
  ::v-deep .pdd-cell .cell {
    overflow: visible;
    padding: 5px;
  }
}
</style>
